import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Chargepoint } from '../../../api/chargepoints-api.service';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';

const HEARTBEAT_LIMIT_PER_TYPE = {
  OCPP: 5,
  OKECHARGE: 11,
  IVY: 15,
  NETATMO: 15
};

@Component({
  selector: 'app-last-heartbeat-info',
  templateUrl: './last-heartbeat-info.component.html',
  styleUrls: ['./last-heartbeat-info.component.scss'],
  imports: [
    CommonModule,
    MatIconModule,
    MatTooltipModule,
  ]
})
export class LastHeartbeatInfoComponent implements OnChanges {

  @Input() chargepoint?: Chargepoint;
  public error?: string;

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['chargepoint']) {
      const lastHeartbeat = this.chargepoint?.lastHeartbeat;
      const type = this.chargepoint?.type;
      this.error = undefined;
      if (lastHeartbeat && type) {
        const now = new Date();
        const timeDiff = now.getTime() - lastHeartbeat.getTime();
        const timeDiffInMinutes = timeDiff / 60000;
        const limit = HEARTBEAT_LIMIT_PER_TYPE[type];
        if (timeDiffInMinutes > limit) {
          this.error = `Last heartbeat is too old.`;
        }
      } else {
        this.error = 'Missing heartbeat';
      }
    }
  }
}
